/**
 * Générateur — Automatisme : multiplier et diviser par 10, 100, 1 000
 * Attendu ID : 1043 | Niveau : 5ème | Domaine : Opérations
 * Rubrique : AUTOMATISME (programme 2025) — « automatisme déjà attendu en
 * 6e » (doc source) : cet attendu 5e EST l'entretien des deux automatismes
 * 6e correspondants.
 *
 * ── WRAPPER (décision prof 2026-08-31) ─────────────────────────────────────
 * Ce gen DÉLÈGUE intégralement aux gens 6e gen_1008 (multiplier par 1, 10,
 * 100, 1 000) et gen_1009 (diviser), déjà criblés, revus et dotés de leurs
 * coups de pouce : zéro duplication de logique, une seule maintenance. Le
 * payload est re-badgé (niveau 5eme, attendu 1043) ; les cartes, formats,
 * generator_keys, invariants (glissement de chaîne sans flottant, item
 * « × 1 » anti-routine, distracteurs nommés) sont ceux des gens 6e.
 * Côté coups de pouce et solveurs, l'entrée 1043 réutilise les entrées
 * 1008 + 1009 (clés produits_* et quotients_*, disjointes) : voir
 * coupsDePouce/index.js et tests/solvers/index.js.
 */
import { generate as genererMultiplication, CATEGORIES as CAT_MULT } from '../../6eme/nombres-decimaux/gen_1008';
import { generate as genererDivision, CATEGORIES as CAT_DIV } from '../../6eme/nombres-decimaux/gen_1009';
import { randomChoice } from '../../../utils';

const ATTENDU_ID = 1043;

const rebadger = (payload) => {
    payload.niveau = '5eme';
    payload.attendu = ATTENDU_ID;
    return payload;
};

export const CATEGORIES = [...CAT_MULT, ...CAT_DIV];

export const generate = (typeExercice) => {
    if (typeExercice && typeExercice.startsWith('produits')) return rebadger(genererMultiplication(typeExercice));
    if (typeExercice && typeExercice.startsWith('quotients')) return rebadger(genererDivision(typeExercice));
    const delegue = randomChoice([genererMultiplication, genererDivision]);
    return rebadger(delegue(typeExercice));
};
